import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { composePageTitle } from './Common';
import Footer from './components/Footer';
import Header from './components/Header';
import Application from './config/application';
import { PageUrl } from './Constants';

const Privacy = () => {
    return (
        <div id="main-wrapper">
            <Helmet title={composePageTitle('Privacy Policy')} />
            <Header />
            <section className="page-header page-header-dark bg-secondary">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-8">
                            <h1>Privacy Policy</h1>
                        </div>
                        <div className="col-md-4">
                            <ul className="breadcrumb justify-content-start justify-content-md-end mb-0">
                                <li>
                                    <RouterLink to={PageUrl.HOME}>Home</RouterLink>
                                </li>
                                <li className="active">Privacy Policy</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <div id="content">
                <div className="container">
                    <div className="bg-white shadow-md rounded p-4 mb-4">
                        <div>
                            <h1>Introduction</h1>
                            <p className="about_txt">
                                {' '}
                                {Application.ORG_DISPLAY_NAME} (“we,” “us,” or “our”) is dedicated to protecting your privacy and maintaining the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your data when you visit our website, {Application.ORG_DISPLAY_NAME}, or utilize our services, including flight bookings, travel packages, and other related offerings.{' '}
                            </p>
                            <p className="about_txt">
                                {' '}
                                By accessing or using our services, you acknowledge and agree to the terms outlined in this Privacy Policy. If you do not agree with these terms, please do not use our website or services.
                            </p>

                            <h3>1.Data We Collect From You</h3>
                            <p>
                                The following personal information may be collected:
                            </p>

                            <h3>A. Data You Provide to Us</h3>
                            <ul className="custom-bullet-list">
                                <li><strong>Contact Information: </strong>Full name, email address, phone number, and mailing address.</li>
                                <li><strong>Booking Details:</strong> Flight information, travel dates, passport number, payment details (such as credit or debit card information), and any special requests (e.g., dietary preferences or accessibility requirements).</li>
                                <li><strong>Account Information:</strong> If you register an account, we may retain your login credentials and user preferences.</li>
                            </ul>

                            <h3>B. Information Gathered Automatically</h3>
                            <ul className="custom-bullet-list">
                                <li><strong>Device and Browser Information:</strong> IP address, device type, operating system, browser version, and unique device identifiers.</li>
                                <li><strong>Usage Information:</strong> Pages you visit, search terms used, booking history, and your interactions with our website.</li>
                                <li><strong>Location Data:</strong> Estimated location based on your IP address or device settings (when enabled).</li>
                            </ul>

                            <h3>C. Data Received from Third Parties</h3>
                            <p>We may obtain information from:</p>
                            <ul className="custom-bullet-list">
                                <li>Airlines, hotels, and travel partners to facilitate and complete your bookings.</li>
                                <li>Payment processors to authenticate and process your transactions.</li>
                                <li>Marketing partners to provide you with special promotions and offers.</li>
                            </ul>

                            <h3>2. How Your Information Is Utilized</h3>
                            <p>Your data is processed to serve the following purposes:</p>
                            <h3>A. Service Fulfillment</h3>
                            <ul className="custom-bullet-list">
                                <li>Manage flight and travel reservations.</li>
                                <li>Keep you informed of booking confirmations, modifications, and cancellations.</li>
                                <li>Assist with customer inquiries.</li>
                            </ul>

                            <h3>B. Personalization and Advertising</h3>
                            <ul className="custom-bullet-list">
                                <li>Deliver promotional emails, with the option to unsubscribe at any time.</li>
                                <li>Show personalized travel offers tailored to your interests.</li>
                                <li>Enhance our website and services by analyzing usage data.</li>
                            </ul>

                            <h3>C. Security and Legal Compliance</h3>
                            <ul className="custom-bullet-list">
                                <li>Detect and prevent fraud, unauthorized use, and unlawful activities.</li>
                                <li>Fulfill legal and regulatory responsibilities, including tax compliance.</li>
                                <li>Uphold and enforce our Terms & Conditions.</li>
                            </ul>

                            <h3>3. When and How We Share Your Information</h3>
                            {' '}
                            We might share your data with:
                            {' '}
                            <h4>A.Travel Service Providers</h4>
                            <ul className="custom-bullet-list">
                                <li> Airlines, hotels, and car rental companies to finalize your bookings.</li>

                            </ul>

                            <h4>B. Partner Services</h4>
                            <ul className="custom-bullet-list">
                                <li>Payment processors, cybersecurity providers, and customer service teams.</li>

                            </ul>

                            <h4>C.Authorized Legal Entities</h4>
                            <ul className="custom-bullet-list">
                                <li> When mandated by law, such as in cases of court orders or fraud investigations.</li>

                            </ul>

                            <h4>D. Transfer of Business Assets</h4>
                            <ul className="custom-bullet-list">
                                <li>In the event of mergers, acquisitions, or the sale of assets.</li>
                            </ul>

                            <p>We <strong> never sell</strong> your personal data to third-party advertisers.</p>

                            <h2>4. Data Protection Protocols</h2>
                            {' '}
                            We use recognized industry practices to secure your data, such as:
                            {' '}
                            <ul className="custom-bullet-list">
                                <li><strong>Encryption:</strong> Protecting payment information during transmission using SSL/TLS protocols.</li>
                                <li><strong>Access Controls:</strong> Limiting employee access to confidential data.</li>
                                <li><strong>Regular Audits:</strong> Conducting ongoing system checks to identify and address vulnerabilities.</li>
                            </ul>
                            <p>
                                While we implement robust security measures, no online system can guarantee absolute protection. If you believe your account has been accessed without authorization, please contact us immediately.
                            </p>

                            <h2>5. Privacy Choices and Rights</h2>
                            <p>Based on where you reside, you might be entitled to:</p>
                            <ul className="custom-bullet-list">
                                <li><strong>View, update, or remove</strong> your personal information.</li>
                                <li>Choose to unsubscribe from marketing messages.</li>
                                <li>Limit how your data is used in specific situations.</li>
                            </ul>
                            <p>To exercise your rights, please reach out to us. We may require identity verification before fulfilling your request.</p>

                            <h2>6. Data Retention Policy</h2>
                            {' '}
                            <p>We keep your information solely for the duration needed to:</p>
                            {' '}
                            <ul className="custom-bullet-list">
                                <li> Completing your bookings.</li>
                                <li> Meeting legal and regulatory requirements.</li>
                                <li> Addressing disputes and enforcing contracts.</li>
                            </ul>

                            <h2>7. Global Data Sharing</h2>
                            <p>
                                If you are located outside the U.S., your data may be transferred to and handled within the U.S., where privacy regulations may vary. By using our services, you agree to this transfer.
                            </p>

                            <h2>8. Privacy of Minors</h2>
                            <p>
                                Our services are designed for users aged 18 and over. We do not intentionally gather personal information from minors.
                            </p>

                            <h2>9. Tracking Technologies and Cookie Usage</h2>
                            <p>
                                Our use of cookies includes:
                            </p>
                            <ul>
                                <li>Improve website performance and features.</li>
                                <li>Monitor and analyze visitor traffic.</li>
                                <li>Provide personalized advertising (you can opt out through your browser settings).</li>
                            </ul>
                            <p>To learn more, please refer to our <strong>Cookie Policy</strong>.</p>

                            <h2>
                                10. Policy Revisions and Updates
                            </h2>
                            <p>
                                We may update this Privacy Policy from time to time. Any changes will be reflected on this page, along with the revised "Last Updated" date. By continuing to use our services after changes are posted, you agree to the updated policy.
                            </p>

                            <h2>
                                11. Contact Us
                            </h2>
                            <p>
                                If you have any questions or concerns regarding this Privacy Policy, please reach out to us via email.
                            </p>


                            <h4 className="top-gap">
                                {' '}
                                <strong>Consent </strong>{' '}
                            </h4>
                            <p className="about_txt">
                                {' '}
                                By accessing or using our website, you acknowledge and agree to the terms of this Privacy Policy.{' '}
                            </p>
                            <h4 className="top-gap">
                                {' '}
                                <strong>Information We Collect </strong>{' '}
                            </h4>
                            <p className="about_txt">
                                {' '}
                                We collect personal information for various purposes, which may include:{' '}
                            </p>
                            <p className="about_txt">
                                {' '}
                                <strong>At the time of request:</strong> We'll clearly explain why we’re asking for certain personal data at the point of collection.
                            </p>
                            <p className="about_txt">
                                {' '}
                                <strong>When you contact us directly:</strong> We may receive information such as your name, email, phone number, message content, and any attachments you provide.
                            </p>

                            <p className="about_txt">
                                {' '}
                                <strong>When you create an account:</strong>  We may collect details including your name, company name, physical address, email address, and telephone number.
                            </p>

                            <h4 className="top-gap">
                                {' '}
                                <strong> How We Use Your Information </strong>{' '}
                            </h4>
                            <p className='about_txt'>We use the information collected for purposes such as:</p>
                            <ul>
                                <li>
                                    Operating and maintaining our website{' '}
                                </li>
                                <li>Enhancing and customizing user experience</li>
                                <li>Analyzing usage trends and traffic</li>
                                <li>Developing new features and services</li>
                                <li>
                                    Communicating updates and service information
                                </li>
                                <li>
                                    Sending promotional communications
                                </li>
                                <li>Detecting and preventing fraud</li>

                            </ul>
                            <h4 className="top-gap">
                                {' '}
                                <strong> Log Files </strong>{' '}
                            </h4>
                            <p className="about_txt">
                                {' '}
                                {Application.ORG_DISPLAY_NAME} follows standard web analytics practices by using log files. These logs may include your IP address, browser type, ISP, timestamps, referring/exit pages, and click activity. This information is not personally identifiable and is used to analyze trends, manage the site, and collect demographic data.

                                {' '}
                            </p>
                            <h4 className="top-gap">
                                {' '}
                                <strong> Advertising Partners Privacy Policies </strong>{' '}
                            </h4>
                            <p className="about_txt">
                                Third-party advertisers on our site may use technologies like cookies, JavaScript, or web beacons to personalize content and measure ad effectiveness. These tools may automatically collect your IP address.   {Application.ORG_DISPLAY_NAME} does not control or access the cookies used by third-party advertisers.
                            </p>
                            <h4 className="top-gap">
                                {' '}
                                <strong> Third Party Privacy Policies </strong>{' '}
                            </h4>
                            <p className="about_txt">
                                {' '}
                                Our Privacy Policy does not extend to third-party websites or services. We recommend reviewing the respective privacy policies of those providers to understand how they collect and manage your data.

                                <br /> You can also manage your cookie preferences through your browser settings.{' '}
                            </p>


                            <h4 className="top-gap">
                                {' '}
                                <strong>
                                    {' '}
                                    California Consumer Privacy Act (CCPA) Rights{' '}
                                </strong>{' '}
                            </h4>
                            <p className="about_txt">
                                {' '}
                                If you are a California resident, you have the right to:{' '}
                            </p>
                            <p className="about_txt">
                                {' '}
                                Request details about the personal data we’ve collected about you{' '}
                            </p>

                            <p className="about_txt">
                                {' '}
                                Request deletion of your personal data{' '}
                            </p>
                            <p className="about_txt">
                                {' '}
                                Opt out of the sale of your personal data{' '}
                            </p>
                            <p className="about_txt">
                                {' '}
                                We will respond to requests within one month. To exercise any of these rights, please contact us.{' '}
                            </p>
                            <h4 className="top-gap">
                                {' '}
                                <strong>General Data Protection Regulation (GDPR) Rights</strong>{' '}
                            </h4>
                            <p className="about_txt">
                                {' '}
                                If you are located in the EU or EEA, you have the following rights regarding your personal data:{' '}
                            </p>
                            <p className="about_txt">
                                {' '}
                                <strong>Right of access:</strong> Request a copy of your personal data{' '}
                            </p>
                            <p className="about_txt">
                                {' '}
                                <strong> Right to rectification:</strong> Correct any inaccurate or incomplete data{' '}
                            </p>
                            <p className="about_txt">
                                {' '}
                                <strong> Right to erasure:</strong> Request deletion of your data, under specific conditions{' '}
                            </p>

                            <p className="about_txt">
                                {' '}
                                <strong>Right to restrict processing:</strong> Limit how we process your data, under certain circumstances{' '}
                            </p>
                            <p className="about_txt">
                                {' '}
                                <strong>Right to object:</strong> Object to the processing of your data{' '}
                            </p>
                            <p className="about_txt">
                                {' '}
                                <strong>Right to data portability:</strong> Request the transfer of your data to another entity or to you directly{' '}
                            </p>
                            <p className="about_txt">
                                {' '}
                                We will respond within one month of receiving your request.{' '}

                            </p>
                            <h4 className="top-gap">
                                {' '}
                                <strong> Children’s Privacy </strong>{' '}
                            </h4>
                            <p className="about_txt">
                                {' '}
                                We are committed to protecting the privacy of minors. Our services are not directed to children under 13, and we do not knowingly collect personal data from them. If you believe your child has provided us with such information, please contact us immediately so we can delete it from our records.{' '}
                            </p>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Privacy;